<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 mb-3>
        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :top="true"
          :right="true"
          :timeout="6000"
          absolute
        >
          {{ message }}
          <v-btn dark text @click="snackbar = false"> CLOSE </v-btn>
        </v-snackbar>
        <v-dialog v-model="addUserDialog" max-width="500px" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">Add User</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-form ref="form" v-model="addUserFormValid" lazy-validation>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="user.firstName"
                        label="First Name"
                        :rules="firstNameRules"
                        required
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="user.lastName"
                        :rules="lastNameRules"
                        label="Last Name"
                        required
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="user.username"
                        :rules="usernameRules"
                        label="Email"
                        required
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-autocomplete
                        v-model="user.roleId"
                        :items="roles"
                        :rules="roleNameRules"
                        item-text="name"
                        item-value="name"
                        label="Role"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="user.idNumber"
                        label="Id Number"
                        :rules="idRules"
                        required
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="user.phoneNumber"
                        :rules="phoneNumberRules"
                        label="Phone Number"
                        required
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="secondary" @click.native="close">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!addUserFormValid"
                color="primary"
                @click.native="createExternalUser"
                >Submit</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="editUserDialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Edit User</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-form
                    ref="EditForm"
                    v-model="editFormValid"
                    lazy-validation
                  >
                    <v-text-field
                      v-model="editedItem.firstName"
                      label="First Name"
                      :rules="firstNameRules"
                      required
                    ></v-text-field>

                    <v-text-field
                      v-model="editedItem.lastName"
                      label="Last Name"
                      :rules="lastNameRules"
                      required
                    ></v-text-field>

                    <v-text-field
                      v-model="editedItem.username"
                      label="Username"
                      :rules="usernameRules"
                      required
                      readonly
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.phoneNumber"
                      label="Phone Number"
                      :rules="phoneNumberRules"
                      required
                    ></v-text-field>

                    <v-autocomplete
                      v-model="editedItem.roleId.name"
                      :items="roles"
                      :rules="roleNameRules"
                      item-text="name"
                      item-value="name"
                      label="Role"
                    ></v-autocomplete>

                    <v-select
                      :items="activeNames"
                      label="Active"
                      v-model="editedItem.active"
                      outline
                      required
                    ></v-select>

                    <v-select
                      :items="accountStatusNames"
                      label="Account Status"
                      v-model="editedItem.accountStatus"
                      outline
                      required
                    ></v-select>

                    <!-- Checkbox for Preferred User -->
                    <v-checkbox
                      v-model="editedItem.preferredUser"
                      label="Preferred User"
                      :true-value="1"
                      :false-value="0"
                    ></v-checkbox>
                  </v-form>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click.native="closeEditD">Cancel</v-btn>
              <v-btn color="primary" @click.native="updateExternalUser"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="editUserDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit User</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
             <v-form ref="EditForm" v-model="editFormValid" lazy-validation>
                <v-text-field
                 v-model="editedItem.firstName"
                 label="First Name"
                 :rules="firstNameRules"
                 required
                 >
                 </v-text-field>

                <v-text-field
                 v-model="editedItem.lastName"
                 label="Last Name"
                 :rules="lastNameRules"
                 required
                 >
                 </v-text-field>

                <v-text-field
                 v-model="editedItem.username"
                 label="Username"
                 :rules="usernameRules"
                 required
                 readonly
                 >
                </v-text-field>

                <v-autocomplete
                  v-model="editedItem.roleId.name"
                  :items="roles"
                  :rules="roleNameRules"
                  item-text="name"
                  item-value='name'
                  label="Role"
                >
                </v-autocomplete>

                <v-select
                  :items="activeNames"
                  label="Active"
                  v-model="editedItem.active"
                  outline
                  required
                >
                </v-select>

                <v-select
                  :items="accountStatusNames"
                  label="Account Status"
                  v-model="editedItem.accountStatus"
                  outline
                  required
                >
                </v-select>

              </v-form>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click.native="closeEditD">Cancel</v-btn>
          <v-btn color="primary" @click.native="updateExternalUser">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
        <v-card-actions v-if="canCreateExternalUsers">
          <v-spacer> </v-spacer>
          <v-btn color="primary" @click="addUser"> Create User </v-btn>
        </v-card-actions>
        <v-data-table
          :headers="headers"
          :items="users"
          :loading="loading"
          loading-text="Loading... Please wait"
          class="elevation-1"
        >
          <template v-slot:[`item.enabled`]="{ item }">
            <v-btn v-if="item.enabled" color="secondary">ACTIVE</v-btn>
            <v-btn v-else color="grey lighten-3">NOT_ACTIVE</v-btn>
          </template>
          <template v-slot:[`item.userLogin`]="{ item }">
            <v-icon v-if="item.trials > 3" color="primary"> lock</v-icon>
            <v-icon v-else color="primary"> lock_open</v-icon>
          </template>
          <td class="justify-center layout px-0">
            <v-icon
              small
              class="mr-2"
              @click="editItem(props.item)"
              v-if="canCreateExternalUsers"
            >
              edit
            </v-icon>
          </td>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              v-if="canCreateExternalUsers"
              >edit</v-icon
            >
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
import config from "../../../config";
import store from "../../../store";

export default {
  name: "viewexternalusers",
  data: function () {
    return {
      headers: [
        { text: "First Name", value: "firstName" },
        { text: "Last Name", value: "lastName" },
        { text: "Username", value: "username" },
        { text: "Phone", value: "phoneNumber" },
        { text: "ID No", value: "idNumber" },
        { text: "Role", value: "roleId.name" },
        { text: "Profile Status", value: "enabled" },
        { text: "Account Status", value: "userLogin" },
        { text: "PreferredUser", value: "preferredUser" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      users: [],
      message: "",
      loading: true,
      pagination: {},
      totalUsers: 0,
      snackbarColor: "",
      snackbar: false,
      addUserDialog: false,
      defaultItem: {
        firstName: "",
        lastName: "",
        username: "",
        roleId: 0,
        idNumber: "",
        phoneNumber: "",
        organisationId: "",
      },
      user: {
        firstName: "",
        lastName: "",
        username: "",
        roleId: 0,
        idNumber: "",
        phoneNumber: "",
        organisationId: "",
      },
      editedItem: {
        firstName: "",
        lastName: "",
        username: "",
        roleId: 0,
        idNumber: "",
        phoneNumber: "",
        accountStatus: "",
        active: "",
        preferredUser: "",
      },
      roles: [],
      firstNameRules: [(v) => !!v || "First Name is required"],
      lastNameRules: [(v) => !!v || "Last Name is required"],
      usernameRules: [
        (v) => !!v || "Username is required",
        // v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      roleNameRules: [(v) => !!v || "Role Name is required"],
      idRules: [
        (v) => !!v || "ID Number is required",
        (v) => /^\d*$/.test(v) || "Only numbers are allowed",
      ],
      phoneNumberRules: [
        (v) => !!v || "Phone Number is required",
        (v) =>
          /^(\+?\d{12}|\d{10})$/.test(v) ||
          'Phone number must be 10 or 12 digits, optionally starting with "+"',
      ],
      addUserFormValid: false,
      permissions: [],
      editUserDialog: false,
      accountStatusNames: ["LOCKED", "NOT_LOCKED"],
      activeNames: ["ACTIVE", "NOT ACTIVE"],
      editFormValid: true,
    };
  },
  watch: {
    user: {
      handler() {
        this.checkFormValidity();
      },
    },
    pagination: {
      handler() {
        this.getDataFromApi().then((data) => {
          // this.users = data.items
          // this.totalUsers = data.total
        });
      },
      deep: true,
    },
  },
  computed: {
    canCreateExternalUsers: function () {
      return this.hasPerm("CAN_CREATE_EXTERNALUSERS");
    },
    canEditUser: function () {
      return this.hasPerm("CAN_UPDATE_EXTERNALUSERS");
    },
  },
  mounted() {
    this.getDataFromApi()
      .then((data) => {
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
    this.getRoles();
    this.permissions = store.state.user.roleId.permissions;
  },
  methods: {
    checkFormValidity() {
      // This will check if all rules pass and update `isFormValid`
      this.addUserFormValid = this.$refs.form.validate();
      console.log("isFormValid", this.addUserFormValid);
    },
    hasPerm(permission) {
      return this.permissions.includes(permission);
    },
    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (item.enabled) {
        this.editedItem.active = "ACTIVE";
      } else {
        this.editedItem.active = "NOT_ACTIVE";
      }

      if (item.userLogin && item.userLogin.trials > 3) {
        this.editedItem.accountStatus = "LOCKED";
      } else {
        this.editedItem.accountStatus = "NOT_LOCKED";
      }
      this.editUserDialog = true;
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let items = this.getUsers();
        const total = items.length;

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy];
            const sortB = b[sortBy];

            if (descending) {
              if (sortA < sortB) return 1;
              if (sortA > sortB) return -1;
              return 0;
            } else {
              if (sortA < sortB) return -1;
              if (sortA > sortB) return 1;
              return 0;
            }
          });
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage);
        }

        setTimeout(() => {
          this.loading = false;
          resolve({
            items,
            total,
          });
        }, 1000);
      });
    },
    getUsers() {
      var url =
        config.serverURI + "/organization/" + this.$route.params.id + "/users";
      axios
        .get(url)
        .then((response) => {
          if (response.status !== 200) {
            this.error = response.statusText;
            console.log("Error is " + this.error);
            return;
          }
          this.users = response.data;
        })
        .catch((error) => {
          // Request failed.
          console.log("error", error.response);
          this.snackbar = true;
          this.snackbarColor = "error";
          this.message = error.response.status;
        });
      return this.users;
    },
    addUser() {
      this.addUserDialog = true;
    },
    close() {
      this.addUserDialog = false;
      this.$refs.form.resetValidation();
      setTimeout(() => {
        this.user = Object.assign({}, this.defaultItem);
      }, 300);
    },
    closeEditD() {
      this.editUserDialog = false;
      this.$refs.EditForm.resetValidation();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
    },
    getRoles() {
      var url = config.serverURI + "/admin/role/getAllExternal";
      axios
        .get(url)
        .then((response) => {
          if (response.status !== 200) {
            console.log("Error is " + this.error);
            return;
          }
          this.roles = response.data;
        })
        .catch((error) => {
          console.log("error", error.response);
        });
    },
    createExternalUser() {
      this.addUserDialog = false;
      if (this.$refs.form.validate()) {
        var url = config.serverURI + "/organization/user/create";
        this.user.organisationId = this.$route.params.id;
        console.log(this.user);
        axios
          .post(url, this.user)
          .then((response) => {
            if (response.data.error !== false) {
              this.message = response.data.message;
              this.snackbar = true;
              this.snackbarColor = "error";
              console.log("Error is " + this.message);
              return;
            }
            this.resetForm();
            this.message = response.data.message;
            this.snackbar = true;
            this.snackbarColor = "primary";
          })
          .catch((error) => {
            console.log("error", error.response);
            this.message = error.response.message;
            this.snackbar = true;
            this.snackbarColor = "error";
          });
      } else {
        console.log("Please submit correct information to the required fields");
        this.message =
          "Please submit correct information to the required fields";
        this.snackbar = true;
        this.snackbarColor = "error";
      }
    },
    resetForm() {
      this.user = Object.assign({}, this.defaultItem);
      this.$refs.form.resetValidation();
    },
    resetEditForm() {
      this.user = Object.assign({}, this.defaultItem);
      this.$refs.EditForm.resetValidation();
    },
    updateExternalUser() {
      this.editUserDialog = false;
      if (this.$refs.EditForm.validate()) {
        var url = config.serverURI + "/organization/user/update";
        this.editedItem.organisationId = this.$route.params.id;
        this.editedItem.roleId = this.editedItem.roleId.name;
        console.log(this.editedItem.preferredUser);
        axios
          .post(url, this.editedItem)
          .then((response) => {
            if (response.data.error !== false) {
              this.message = response.data.message;
              this.snackbar = true;
              this.snackbarColor = "error";
              console.log("Error is " + this.message);
              return;
            }
            this.resetEditForm();
            this.message = response.data.message;
            this.snackbar = true;
            this.snackbarColor = "primary";
          })
          .catch((error) => {
            console.log("error", error);
            this.message = error.response.message;
            this.snackbar = true;
            this.snackbarColor = "error";
          });
      }
    },
  },
};
</script>
<style></style>
